import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const MapViewUpdater = ({ geoJsonData, fallbackView, desiredZoom = 6 }) => {
    const map = useMap();

    useEffect(() => {
        if (fallbackView) {
            map.setView(fallbackView.center, fallbackView.zoom, { animate: true });
            return;
        }

        if (geoJsonData) {
            const layer = new L.GeoJSON(geoJsonData);
            const bounds = layer.getBounds();
            if (bounds.isValid()) {
                const center = bounds.getCenter();
                const ne = bounds.getNorthEast();
                const sw = bounds.getSouthWest();
                const latDiff = Math.abs(ne.lat - sw.lat);
                const lngDiff = Math.abs(ne.lng - sw.lng);

                let zoomOffset = 0;
                if (latDiff < 0.5 && lngDiff < 0.5) {
                    zoomOffset = 4;
                } else if (latDiff < 1 && lngDiff < 1) {
                    zoomOffset = 1;
                }

                const computedZoom = desiredZoom + zoomOffset;
                map.setView(center, computedZoom, { animate: true });
            }
        }
    }, [geoJsonData, fallbackView, map, desiredZoom]);

    return null;
};

export default MapViewUpdater;
